<template>
<div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Create a new project</h5>

          <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="form-group">
              <label>Project Name</label>
              <input type="text" v-model="projname" class="form-control input-lg">
            </div>
            
            
              <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
              @click="createProject()">Save</button>
            
          </form>
        </div>
      </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "Modal Config Edit",
  components: {  },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
  },
  data() {
    return {
      projectid: '',
      projname: ''
    };
  },
  methods: {
    createProject() {
      let formData = new FormData();
      formData.append('projname', this.projname);
      for (const pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
            axios.post('/create_project', formData)
                .then(
                (response) => {
                    this.projects = response.data;
                    // console.log('returned list '+this.projects);
                    this.$emit('customChange', {shell: 'Projects', dataset: ''});
                    this.$emit('closeModal');
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            });  
    }
    
  }
}
</script>